export default __webpack_public_path__ + "static/media/ChaltenPrototype30.55e8a62a.jpg";